import dayjs from 'dayjs'

import { flexibleDateRange } from 'shared/constants/tours'

export const getFlexibleDateRange = (startDate: string) => {
  const selectedDate = dayjs(startDate)
  const today = dayjs().startOf('day')
  const tomorrow = today.add(1, 'day')

  const isTodayOrTomorrow =
    selectedDate.isSame(today, 'day') || selectedDate.isSame(tomorrow, 'day')

  const startRange = isTodayOrTomorrow
    ? selectedDate
    : selectedDate.subtract(flexibleDateRange, 'day')
  const endRange = selectedDate.add(flexibleDateRange, 'day')

  return {
    startRange: startRange.format('YYYY-MM-DD'),
    endRange: endRange.format('YYYY-MM-DD'),
  }
}
